<template>
  <div class="image-uploader">
    <input type="file" accept="image/jpeg,image/png,image/webp,image/jpg" @change="onFileChange" :disabled="loading" />
    <div v-if="previewUrl" class="image-preview">
      <img :src="previewUrl" alt="Image Preview" />
    </div>
    <div v-if="loading" class="upload-status">Uploading...</div>
    <div v-if="error" class="upload-error">{{ error }}</div>
    <div v-if="success" class="upload-success">Image uploaded successfully!</div>
  </div>
</template>

<script>
import apiService from '../apiService';

export default {
  name: 'ImageUploader',
  props: {
    password: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      previewUrl: null,
      loading: false,
      error: null,
      success: false
    };
  },
  methods: {
    async onFileChange(event) {
      const file = event.target.files[0];
      this.error = null;
      this.success = false;
      if (!file) {
        this.previewUrl = null;
        return;
      }
      // Validate file type
      const validTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/jpg'];
      if (!validTypes.includes(file.type)) {
        this.error = 'Invalid file type. Please select a JPG, JPEG, PNG, or WEBP image.';
        this.previewUrl = null;
        return;
      }
      this.previewUrl = URL.createObjectURL(file);
      // Prepare FormData
      const formData = new FormData();
      formData.append('image', file);
      formData.append('password', this.password);
      this.loading = true;
      try {
        const response = await apiService.uploadAlbumImage(formData);
        if (response && response.success && response.imageUrl) {
          this.success = true;
          this.$emit('image-uploaded', response.imageUrl);
        } else {
          this.error = 'Upload failed. No image URL returned.';
        }
      } catch (err) {
        this.error = err.message || 'Image upload failed.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.image-uploader {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.image-preview img {
  max-width: 200px;
  max-height: 200px;
  border-radius: 8px;
  margin-top: 10px;
  border: 1px solid #444;
}
.upload-status {
  color: #00bcd4;
  font-weight: bold;
}
.upload-error {
  color: #ff5252;
  font-weight: bold;
}
.upload-success {
  color: #4caf50;
  font-weight: bold;
}
</style> 